import { observer } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import { IItemRendererProps, Select } from '@blueprintjs/select';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import { Button, MenuItem } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { TranslatedMessage } from '../translation';
import { Municipality } from '../../../store/models/Municipality';

interface CitySelectionProps extends WithTranslateProps {
  cityList: Array<Instance<typeof Municipality>>;
  onChange?: (municipality: Instance<typeof Municipality>) => void;
  selectedMunicipality?: Instance<typeof Municipality>;
}

@observer
class CitySelection extends React.Component<CitySelectionProps> {
  onSelect = async (value) => {
    if (this.props.onChange !== null && this.props.onChange !== undefined) {
      this.props.onChange!(value!);
    }
  };

  get TypedSelectInput() {
    return Select.ofType<Instance<typeof Municipality>>();
  }

  renderMunicipalityMenuItem(
    item: Instance<typeof Municipality>,
    { handleClick, index, modifiers }: IItemRendererProps,
  ) {
    if (modifiers.matchesPredicate) {
      const { selectedMunicipality } = this.props;
      return (
        <MenuItem
          key={`municipality-${index}`}
          active={
            (selectedMunicipality === undefined && item.municipalityId === undefined) ||
            (selectedMunicipality !== undefined &&
              item !== undefined &&
              item.municipalityId === selectedMunicipality.municipalityId)
          }
          onClick={handleClick}
          text={item.postalCode + ' ' + item.nameFR! + ' (' + item.mainNameFR + ')'}
        />
      );
    } else {
      return null;
    }
  }

  getMunicipalityText = (municipality): React.ReactNode => {
    return municipality.postalCode + ' ' + municipality.nameFR! + ' (' + municipality.mainNameFR + ')';
  };

  filterMunicipality = (query, Municipality) => {
    const label = Municipality !== null ? Municipality.postalCode + Municipality.nameFR + Municipality.mainNameFR : '';
    return (
      label
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .indexOf(
          query
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase(),
        ) >= 0
    );
  };

  render() {
    const { cityList, selectedMunicipality } = this.props;

    console.log(this.props);

    const TypedSelectInput = this.TypedSelectInput;
    return (
      <div>
        <TypedSelectInput
          onItemSelect={(item) => {
            this.onSelect(item);
          }}
          items={toJS(cityList)}
          // @ts-ignore
          itemRenderer={(item, props) => this.renderMunicipalityMenuItem(item, props)}
          itemPredicate={this.filterMunicipality}
          popoverProps={{ minimal: true }}
          resetOnSelect={true}
          {...this.props}
        >
          <Button
            rightIcon="caret-down"
            text={
              selectedMunicipality !== undefined && selectedMunicipality !== null ? (
                <span>{this.getMunicipalityText(selectedMunicipality)}</span>
              ) : (
                <TranslatedMessage id={TLCode.TRANSFER_CHOOSE_A_Municipality} />
              )
            }
          />
        </TypedSelectInput>
      </div>
    );
  }
}

export default withTranslate(CitySelection);
